import { Language } from "@mui/icons-material";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const addDonation = createAsyncThunk(
  "DonationCart/addDonation",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi("Donation/Create", data, token);
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const addProduct = createAsyncThunk(
  "DonationCart/addProduct",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi("Donation/UpdateProduct", data, token);
      return res;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const addEventProduct = createAsyncThunk(
  "DonationCart/addEventProduct",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi("Donation/UpdateEventProduct", data, token);
      return res;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);


export const getProductList = createAsyncThunk(
  "DonationCart/getProductList",
  async (data, { getState }) => {
    try {
      const language = "pg";
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Donation/GetProductList?language=${language}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getProductUnits = createAsyncThunk(
  "DonationCart/GetProductUnits",
  async (productId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Donation/GetProductUnits?productId=${productId}`,
        token
      );
      return { productId, data: rsp.data }
    } catch (error) {
      throw error;
    }
  }
);

// export const activateDonation = createAsyncThunk(
//   "DonationCart/activateDonation",
//   async (data) => {
//     try {
//       const res = await API.patchDataApi('Donation/');
//     }
//   }
// );
// export const updateProduct = createAsyncThunk(
//     "DonationCart/updateProduct",
//     async ({data, navigate}, { getState }) => {
//       try {
//         const {auth: {user: { token}}} = getState();
//         await API.register(data);
//         // navigate('/multistep')
//       } catch (error) {
//         // rejectWithValue(error.response.data);
//         throw error;
//       }
//     }
//   );

export const updateDonation = createAsyncThunk(
  "DonationCart/updateDonation",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      await API.postDataApi("Donation/UpdateDonationDetails", data, token);
      // navigate('/multistep')
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const addRating = createAsyncThunk(
  "DonationCart/addRating",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      await API.postDataApi("Donation/AddRating", data, token);
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const addCollectorInviteForDonation = createAsyncThunk(
  "DonationCart/addCollectorInviteForDonation",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      await API.postDataApi('Collection/AddCollectionInvite', data, token);
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);



const removeAtIndex = (arr, index) => {
  return arr.filter((_, i) => i !== index);
};

const initialState = {
  donationId: "",
  donationType: "donation",
  donationTab: "product",
  donationAddressTab: "1",
  productList: [],
  products: [],
  res: {},
  status: "idle",
  loading: false,
  updateDonationDetail: {},
  recolhaDate: false,
  startDate: false,
  endDate: false,
  animalEndDate: false,
  selectProductError: false,
  addRating: {},
  collectorInvite:{},
  collectorInviteNames:[],
  unitsByProduct: {},
};
export const donationSlice = createSlice({
  name: "DonationCart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const { id, productId, ...rest } = action.payload;
      const { products = [] } = state;
      const productList = products.map((product) => product.productId);
      if (productList.includes(productId)) {
        // await API.getDataApi('Donation/GetActiveDonation');
        state.products[productList.indexOf(productId)].count++;
      } else {
        state.products.push({
          count: 1,
          unitIndex: 0,
          productId,
          ...rest,
        });
      }
    },
    removeItem: ({ products, ...rest }, action) => {
      const { productId } = action.payload;
      const productList = products.map((product) => product.productId);
      if (productList.includes(productId)) {
        const productIndex = productList.indexOf(productId);
        if (products[productIndex].count > 1) {
          products[productIndex].count--;
        } else {
          return {
            products: removeAtIndex(products, productIndex),
            ...rest,
          };
        }
      }
    },
    deleteItem: ({ products, ...rest }, action) => {
      const { productId } = action.payload;
      const productList = products.map((product) => product.productId);
      if (productList.includes(productId)) {
        const productIndex = productList.indexOf(productId);
        return {
          products: removeAtIndex(products, productIndex),
          ...rest,
        };
      }
    },
    valueItem: (state, action) => {
      const { productId, value } = action.payload;
      const productList = state.products.map((product) => product.productId);
      const productIndex = productList.indexOf(productId);
      if (productList.includes(productId)) {
        if (value > 0 || value === "") {
          state.products[productIndex].count = value;
        } else {
          state.products = removeAtIndex(state.products, productIndex);
        }
      }
    },
    setUnitSelectedIndex: (state, action) => {
      const { productId, index } = action.payload;
      const productList = state.products.map((product) => product.productId);
      if (productList.includes(productId)) {
        state.products[productList.indexOf(productId)].unitIndex = index;
      }
    },
    setRecolhaDate: (state, action) => {
      state.recolhaDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setAnimalEndDate: (state, action) => {
      state.animalEndDate = action.payload;
    },
    setCollectorInviteNames: (state, action) => {
      state.collectorInviteNames = action.payload;
    },
    setUpdateDonationDetail: (state, action) => {
      state.updateDonationDetail = action.payload;
    },
    setDonationType: (state, action) => {
      state.donationType = action.payload;
    },
    setSelectProductError: (state, action) => {
      state.selectProductError = action.payload;
    },
    setDonationTab: (state, action) => {
      state.donationTab = action.payload;
    },
    setDonationId: (state, action) => {
      state.donationId = action.payload;
    },
    DonationId: (state, action) => {
      state.donationId = action.payload;
    },
    clearCart: ({ products, donationId, ...rest }) => {
      return {
        ...rest,
        donationId: donationId,
        products: [],
      };
    },
    clearDonationCart: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDonation.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(addDonation.fulfilled, (state, action) => {
        state.status = "idle";
        state.donationId = action.payload.donationId;
      })
      .addCase(addDonation.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(addRating.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(addRating.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.addRating = action.payload;
      })
      .addCase(addRating.rejected, (state, action) => {
        state.status = "idle";
        state.loading = "false";
      })
      .addCase(addCollectorInviteForDonation.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(addCollectorInviteForDonation.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.collectorInvite = action.payload;
      })
      .addCase(addCollectorInviteForDonation.rejected, (state, action) => {
        state.status = "idle";
        state.loading = "false";
      })
      .addCase(getProductList.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getProductList.fulfilled, (state, action) => {
        state.status = "idle";
        state.productList = action.payload.obj;
      })
      .addCase(getProductList.rejected, (state, action) => {
        state.status = "idle";
      })
       .addCase(getProductUnits.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getProductUnits.fulfilled, (state, action) => {
        state.status = "idle";
        const { productId, data } = action.payload;
        state.unitsByProduct[productId] = data;
      })
      .addCase(getProductUnits.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(addProduct.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.status = "idle";
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(addEventProduct.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(addEventProduct.fulfilled, (state, action) => {
        state.status = "idle";
      })
      .addCase(addEventProduct.rejected, (state, action) => {
        state.status = "idle";
      });
  },
});
export const {
  addItem,
  removeItem,
  deleteItem,
  valueItem,
  setDonationId,
  setDonationType,
  clearCart,
  setDonationTab,
  setCollectorInviteNames,
  setSelectProductError,
  clearDonationCart,
  setUpdateDonationDetail,
  setUnitSelectedIndex,
  setRecolhaDate,
  setStartDate,
  setEndDate,
  setAnimalEndDate
} = donationSlice.actions;

//why we use this? export const selectLang = (state) => state;

export default donationSlice.reducer;
